(function () {
  var OMNISEND_EMBED_PREFIX = 'omnisend-embedded-v2-';
  var OMNISEND_FORM_TIMEOUT = 8000;
  var OMNISEND_SUBMIT_TIMEOUT = 12000;

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function getOmnisendEmbed(formId) {
    return document.getElementById(OMNISEND_EMBED_PREFIX + formId);
  }

  function getOmnisendControls(formId) {
    var embed = getOmnisendEmbed(formId);

    if (!embed) {
      return null;
    }

    return {
      embed: embed,
      form: embed.querySelector('form'),
      emailInput: embed.querySelector('input[name="emailField"], input[type="email"]'),
      submitButton: embed.querySelector('button[type="submit"], button:not([type]), input[type="submit"]')
    };
  }

  function waitForOmnisendControls(formId) {
    return new Promise(function (resolve, reject) {
      var timeoutId;
      var observer;

      function cleanup() {
        window.clearTimeout(timeoutId);

        if (observer) {
          observer.disconnect();
        }
      }

      function check() {
        var controls = getOmnisendControls(formId);

        if (controls && controls.form && controls.emailInput) {
          cleanup();
          resolve(controls);
        }
      }

      timeoutId = window.setTimeout(function () {
        cleanup();
        reject(new Error('Omnisend form did not load in time.'));
      }, OMNISEND_FORM_TIMEOUT);

      observer = new MutationObserver(check);
      observer.observe(getOmnisendEmbed(formId) || document.body, { childList: true, subtree: true });

      check();
    });
  }

  function normalizeOmnisendFormId(formId) {
    return (formId || '').replace(OMNISEND_EMBED_PREFIX, '').trim();
  }

  function waitForOmnisendSubmit(formId, email) {
    return new Promise(function (resolve, reject) {
      var timeoutId;
      var normalizedEmail = email.toLowerCase();

      function cleanup() {
        window.clearTimeout(timeoutId);
        window.removeEventListener('omnisendForms', handleSubmit);
      }

      function handleSubmit(event) {
        var detail = event.detail || {};
        var eventType = detail.type || detail.eventName;
        var eventFormId = normalizeOmnisendFormId(detail.form && detail.form.id);
        var formValues = detail.formValues || {};
        var eventEmail = (formValues.emailField || '').toLowerCase();

        if (eventType !== 'submit') {
          return;
        }

        if (eventFormId && eventFormId !== formId) {
          return;
        }

        if (eventEmail && eventEmail !== normalizedEmail) {
          return;
        }

        cleanup();
        resolve();
      }

      timeoutId = window.setTimeout(function () {
        cleanup();
        reject(new Error('Omnisend submit event timed out.'));
      }, OMNISEND_SUBMIT_TIMEOUT);

      window.addEventListener('omnisendForms', handleSubmit);
    });
  }

  function setInputValue(input, value) {
    var valueSetter = Object.getOwnPropertyDescriptor(input, 'value') && Object.getOwnPropertyDescriptor(input, 'value').set;
    var prototype = Object.getPrototypeOf(input);
    var prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value') && Object.getOwnPropertyDescriptor(prototype, 'value').set;

    if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
      prototypeValueSetter.call(input, value);
    } else {
      input.value = value;
    }

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function showFormMessage(form, type, message) {
    var successMessage = form.querySelector('[data-wyw-omnisend-success]');
    var errorMessage = form.querySelector('[data-wyw-omnisend-error]');
    var hasMessage = type === 'success' || type === 'error';

    form.classList.toggle('win-your-wishlist__subscribe-form--has-message', hasMessage);

    if (successMessage) {
      successMessage.hidden = type !== 'success';
    }

    if (errorMessage) {
      errorMessage.hidden = type !== 'error';

      if (message) {
        errorMessage.textContent = message;
      }
    }
  }

  function setOmnisendLoading(form, isLoading) {
    var button = form.querySelector('[data-wyw-omnisend-button]');

    form.classList.toggle('win-your-wishlist__subscribe-form--loading', isLoading);
    form.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    if (!button) {
      return;
    }

    if (!button.dataset.originalText) {
      button.dataset.originalText = button.textContent.trim();
    }

    button.disabled = isLoading;
    button.textContent = isLoading ? 'Subscribing...' : button.dataset.originalText;
  }

  async function submitOmnisendForm(form, formId, email) {
    var controls = await waitForOmnisendControls(formId);
    var submitPromise = waitForOmnisendSubmit(formId, email);

    setInputValue(controls.emailInput, email);

    if (controls.submitButton) {
      controls.submitButton.click();
    } else if (controls.form.requestSubmit) {
      controls.form.requestSubmit();
    } else {
      controls.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    await submitPromise;
  }

  function initOmnisendSubscribeForm(form) {
    if (!form || form.dataset.wywOmnisendInitialized === 'true') {
      return;
    }

    form.dataset.wywOmnisendInitialized = 'true';

    form.addEventListener('submit', function (event) {
      var formId = normalizeOmnisendFormId(form.dataset.omnisendFormId);
      var emailInput = form.querySelector('input[type="email"]');
      var email = (emailInput && emailInput.value || '').trim();

      event.preventDefault();
      showFormMessage(form, null);

      if (!formId) {
        showFormMessage(form, 'error', 'Subscription form is not configured.');
        return;
      }

      if (!email || !isValidEmail(email)) {
        showFormMessage(form, 'error', 'Please enter a valid email address.');

        if (emailInput) {
          emailInput.focus();
        }

        return;
      }

      setOmnisendLoading(form, true);

      submitOmnisendForm(form, formId, email)
        .then(function () {
          showFormMessage(form, 'success');
        })
        .catch(function () {
          showFormMessage(form, 'error', 'We could not complete your subscription. Please try again.');
        })
        .finally(function () {
          setOmnisendLoading(form, false);
        });
    });
  }

  function initWinYourWishlist(root) {
    if (!root || root.dataset.wywInitialized === 'true') {
      return;
    }

    root.dataset.wywInitialized = 'true';

    root.querySelectorAll('[data-wyw-scroll-to-block2]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = root.querySelector('[data-wyw-block2-target]');

        if (!target) {
          return;
        }

        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var targetId = link.getAttribute('href');

        if (!targetId || targetId === '#') {
          return;
        }

        var target = document.querySelector(targetId);

        if (!target) {
          return;
        }

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    root.querySelectorAll('[data-wyw-omnisend-form]').forEach(initOmnisendSubscribeForm);
  }

  function initAllWinYourWishlistSections(scope) {
    (scope || document).querySelectorAll('.win-your-wishlist').forEach(initWinYourWishlist);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllWinYourWishlistSections(document);
    });
  } else {
    initAllWinYourWishlistSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllWinYourWishlistSections(event.target);
  });
})();
